import { TextInputFormik } from '@strata/react-inputs';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { validationStrings } from '@strata/strata-ui-strings';
import * as Yup from 'yup';

import { UpdateAddressReasons } from 'services/constants';

export const UpdateMemberDataAddress = () => (
    <>
        <TextInputFormik id="memberAddress1" label="Address Line 1" required />
        <TextInputFormik id="memberAddress2" label="Address Line 2" />
        <TextInputFormik id="memberCity" label="City" required />
        <TextInputFormik id="memberState" label="State" required />
        <TextInputFormik id="memberZip" label="Zip Code" required />
        <SuggestSingleSelectFormik
            id="reason"
            label="Reason"
            placeholderText="Select update reason"
            required
            values={UpdateAddressReasons}
        />
    </>
);

UpdateMemberDataAddress.initialValues = () => ({});

UpdateMemberDataAddress.validationSchema = {
    memberAddress1: Yup.string().required(validationStrings.requiredField.errorMessage),
    memberAddress2: Yup.string(),
    memberCity: Yup.string().required(validationStrings.requiredField.errorMessage),
    memberState: Yup.string().required(validationStrings.requiredField.errorMessage),
    memberZip: Yup.string().required(validationStrings.requiredField.errorMessage),
    reason: Yup.string()
        .oneOf(UpdateAddressReasons)
        .required(validationStrings.requiredField.errorMessage),
};

UpdateMemberDataAddress.onSubmit = async ({
    treatmentDetails,
    memberDetails,
    values,
    patchMemberAddress,
}) => {
    const { payerId, treatmentId, activeReferral } = treatmentDetails;
    const { referralId } = activeReferral ?? {};
    const { memberId, firstName, dateOfBirth } = memberDetails;
    const { memberAddress1, memberAddress2, memberCity, memberState, memberZip, reason } = values;
    await patchMemberAddress({
        payerId,
        memberId,
        firstName,
        dateOfBirth,
        memberAddress1,
        memberAddress2,
        memberCity,
        memberState,
        memberZip,
        referralId,
        treatmentId,
        reason,
    }).unwrap();
};
